<template>
  <div>
    <Header v-bind:HeaderCheck = "HeaderCheck"></Header>
    <div id="content" style="background-color: white">
      <div id="breadcrumb"  style="height: 70px;background-color: #F6F7FB">
        <!-- breadcrumb starts-->
        <div class="container">
        </div>
      </div>
      <div class="container">
        <div class="one">
          <div class="two-third">
            <section class="flex-container">
              <div class="flexslider single-portfolio-item-slider">
                <ul class="slides round">
                  <li>
                    <img :src="productImgUrl" alt=" "/>
                  </li>
<!--                  <li>-->
<!--                    <img :src="productImgUrl" alt=" "/>-->
<!--                  </li>-->
<!--                  <li>-->
<!--                    <img :src="productImgUrl" alt=" "/>-->
<!--                  </li>-->
                </ul>
              </div>
            </section>
          </div>
          <div class="one-third">
            <h4 v-html="productTitle"></h4>
            <p v-html="productText">
            </p><br/>

            <ul class="accordion">
              <li class="accordion-item">
                <div class="accordion-switch">
                  <span class="togglegfx"></span>{{$t('product.part1.tip1')}}
                </div>
                <div class="accordion-content">
                  <h5 v-html="productAboutClient.h"></h5>
                  <p v-html="productAboutClient.p">
                  </p>
                  <p><a href="#" v-html="productAboutClient.link"></a></p>
                </div>
              </li>
              <li class="accordion-item">
                <div class="accordion-switch">
                  <span class="togglegfx"></span>{{$t('product.part1.tip2')}}
                </div>
                <div class="accordion-content">
                  <p v-html="productSkill"></p>
                </div>
              </li>
              <li class="accordion-item">
                <div class="accordion-switch">
                  <span class="togglegfx"></span>{{$t('product.part1.tip3')}}
                </div>
                <div class="accordion-content">
                  <p v-html="productDetails"></p>
                </div>
              </li>
            </ul>

          </div>
        </div>
      </div>
      <div class="intro-features"><!-- intro features panel starts -->
        <Case v-on:change-case="changeCase"></Case>
<!--        <div class="container">-->
<!--          <h4>Our Latest Projects</h4>-->
<!--          <div class="slidewrap">-->
<!--            &lt;!&ndash;project carousel starts&ndash;&gt;-->
<!--            <ul class="slider" id="sliderName">-->
<!--              <li class="slide">&lt;!&ndash; carousel item starts &ndash;&gt;-->
<!--                <div class="one-fourth">-->
<!--                  <div class="item-wrapp">-->
<!--                    <div class="portfolio-item">-->
<!--                      <a href="single-project-small.html" class="item-permalink"><i class="icon-link"></i></a>-->
<!--                      <a href="images/portfolio/portfolio-item-1.jpg" data-rel="prettyPhoto" class="item-preview"><i class="icon-zoom-in"></i></a>-->
<!--                      <img src="images/portfolio/portfolio-item-1.jpg" alt=""/>-->
<!--                    </div>-->
<!--                    <div class="portfolio-item-title">-->
<!--                      <a href="single-project-small.html">Custom WordPress Theme</a>-->
<!--                      <p>-->
<!--                        Design / Development-->
<!--                      </p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="one-fourth">-->
<!--                  <div class="item-wrapp">-->
<!--                    <div class="portfolio-item">-->
<!--                      <a href="single-project-small.html" class="item-permalink"><i class="icon-link"></i></a>-->
<!--                      <a href="images/portfolio/portfolio-item-1.jpg" data-rel="prettyPhoto" class="item-preview"><i class="icon-zoom-in"></i></a>-->
<!--                      <img src="images/portfolio/portfolio-item-1.jpg" alt=""/>-->
<!--                    </div>-->
<!--                    <div class="portfolio-item-title">-->
<!--                      <a href="single-project-small.html">Custom WordPress Theme</a>-->
<!--                      <p>-->
<!--                        Design / Development-->
<!--                      </p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="one-fourth">-->
<!--                  <div class="item-wrapp">-->
<!--                    <div class="flexslider portfolio-items-slider fade">-->
<!--                      <ul class="slides">-->
<!--                        <li><img src="images/portfolio/portfolio-item-2.jpg" alt=""/></li>-->
<!--                        <li><img src="images/portfolio/portfolio-item-3.jpg" alt=""/></li>-->
<!--                        <li><img src="images/portfolio/portfolio-item-4.jpg" alt=""/></li>-->
<!--                      </ul>-->
<!--                    </div>-->
<!--                    <div class="portfolio-item-title">-->
<!--                      <a href="single-project-small.html">Custom WordPress Theme</a>-->
<!--                      <p>-->
<!--                        Design / Development-->
<!--                      </p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="one-fourth">-->
<!--                  <div class="item-wrapp">-->
<!--                    <div class="portfolio-item">-->
<!--                      <a href="single-project-small.html" class="item-permalink"><i class="icon-link"></i></a>-->
<!--                      <a href="images/portfolio/portfolio-item-1.jpg" data-rel="prettyPhoto" class="item-preview"><i class="icon-zoom-in"></i></a>-->
<!--                      <img src="images/portfolio/portfolio-item-1.jpg" alt=""/>-->
<!--                    </div>-->
<!--                    <div class="portfolio-item-title">-->
<!--                      <a href="single-project-small.html">Custom WordPress Theme</a>-->
<!--                      <p>-->
<!--                        Design / Development-->
<!--                      </p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </li>-->
<!--              <li class="slide">&lt;!&ndash; carousel item starts &ndash;&gt;-->
<!--                <div class="one-fourth">-->
<!--                  <div class="item-wrapp">-->
<!--                    <div class="portfolio-item">-->
<!--                      <a href="single-project-small.html" class="item-permalink"><i class="icon-link"></i></a>-->
<!--                      <a href="images/portfolio/portfolio-item-1.jpg" data-rel="prettyPhoto" class="item-preview"><i class="icon-zoom-in"></i></a>-->
<!--                      <img src="images/portfolio/portfolio-item-1.jpg" alt=""/>-->
<!--                    </div>-->
<!--                    <div class="portfolio-item-title">-->
<!--                      <a href="single-project-small.html">Custom WordPress Theme</a>-->
<!--                      <p>-->
<!--                        Design / Development-->
<!--                      </p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="one-fourth">-->
<!--                  <div class="item-wrapp">-->
<!--                    <div class="portfolio-item">-->
<!--                      <a href="single-project-small.html" class="item-permalink"><i class="icon-link"></i></a>-->
<!--                      <a href="images/portfolio/portfolio-item-1.jpg" data-rel="prettyPhoto" class="item-preview"><i class="icon-zoom-in"></i></a>-->
<!--                      <img src="images/portfolio/portfolio-item-1.jpg" alt=""/>-->
<!--                    </div>-->
<!--                    <div class="portfolio-item-title">-->
<!--                      <a href="single-project-small.html">Custom WordPress Theme</a>-->
<!--                      <p>-->
<!--                        Design / Development-->
<!--                      </p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="one-fourth">-->
<!--                  <div class="item-wrapp">-->
<!--                    <div class="portfolio-item">-->
<!--                      <a href="single-project-small.html" class="item-permalink"><i class="icon-link"></i></a>-->
<!--                      <a href="images/portfolio/portfolio-item-1.jpg" data-rel="prettyPhoto" class="item-preview"><i class="icon-zoom-in"></i></a>-->
<!--                      <img src="images/portfolio/portfolio-item-1.jpg" alt=""/>-->
<!--                    </div>-->
<!--                    <div class="portfolio-item-title">-->
<!--                      <a href="single-project-small.html">Custom WordPress Theme</a>-->
<!--                      <p>-->
<!--                        Design / Development-->
<!--                      </p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="one-fourth">-->
<!--                  <div class="item-wrapp">-->
<!--                    <div class="portfolio-item">-->
<!--                      <a href="single-project-small.html" class="item-permalink"><i class="icon-link"></i></a>-->
<!--                      <a href="images/portfolio/portfolio-item-1.jpg" data-rel="prettyPhoto" class="item-preview"><i class="icon-zoom-in"></i></a>-->
<!--                      <img src="images/portfolio/portfolio-item-1.jpg" alt=""/>-->
<!--                    </div>-->
<!--                    <div class="portfolio-item-title">-->
<!--                      <a href="single-project-small.html">Custom WordPress Theme</a>-->
<!--                      <p>-->
<!--                        Design / Development-->
<!--                      </p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </li>-->
<!--            </ul>&lt;!&ndash; carousel items UL ends &ndash;&gt;-->
<!--            <ul class="slidecontrols">-->
<!--              <li><a href="#sliderName" class="prev">Prev</a></li>-->
<!--              <li><a href="#sliderName" class="next">Next</a></li>-->

<!--            </ul>-->
<!--          </div>-->
<!--        </div>-->
      </div><!-- intro features panel ends -->
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/common/Header'
import Footer from '@/components/common/Footer'
import Case from '@/components/common/Case'

const HeaderCheck = {
  tip1: '',
  tip2: '',
  tip3: 'current',
  tip4: '',
  tip5: ''
}
var content = {
  imgUrl: 'static/img/productView/img_xiaoyan_big.png',
  title: 'product.xiaoyan.title',
  text: 'product.xiaoyan.text',
  aboutClient: {
    h: 'product.xiaoyan.aboutClient.h',
    p: 'product.xiaoyan.aboutClient.p',
    link: 'product.xiaoyan.aboutClient.link'
  },
  skill: 'product.xiaoyan.skill',
  details: 'product.xiaoyan.details'
}
export default {
  name: 'Product',
  components: {Case, Footer, Header},
  data: function () {
    return {
      HeaderCheck: HeaderCheck
    }
  },
  created () {
    this.changeContent()
  },
  computed: {
    productImgUrl: {
      get: function () {
        return content.imgUrl
      }
    },
    productTitle: {
      get: function () {
        return this.$t(content.title)
      }
    },
    productText: {
      get: function () {
        return this.$t(content.text)
      }
    },
    productAboutClient: {
      get: function () {
        return {
          h: this.$t(content.aboutClient.h),
          p: this.$t(content.aboutClient.p),
          link: this.$t(content.aboutClient.link)
        }
      }
    },
    productSkill: {
      get: function () {
        return this.$t(content.skill)
      }
    },
    productDetails: {
      get: function () {
        return this.$t(content.details)
      }
    }
  },
  methods: {
    changeContent () {
      const data = this.$route.params.name
      content = {
        imgUrl: 'static/img/productView/img_' + data + '_big.png',
        title: 'product.' + data + '.title',
        text: 'product.' + data + '.text',
        aboutClient: {
          h: 'product.' + data + '.aboutClient.h',
          p: 'product.' + data + '.aboutClient.p',
          link: 'product.' + data + '.aboutClient.link'
        },
        skill: 'product.' + data + '.skill',
        details: 'product.' + data + '.details'
      }
      console.log(content)
    },
    changeCase: function (data) {
      const router = this.$router
      router.push({ path: data.name })
      // router.go(0)
      window.location.reload()
      window.scrollTo(0, 0)
    }
  },
  activated () {
    console.log('jihuo')
    // this.$router.go(0)
    window.location.reload()
  },
  inject: ['reload'],
  watch: {
    // 检测路由参数发生改变时，刷新当前页面 调用
    '$route': function () {
      this.reload()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/view/Product.vue